<template>
  <div class="pagination">
    <div/>
    <div class="pagination-box">
      <el-pagination
          :current-page="pageData.page"
          background
          :small="small"
          :layout="layout"
          :page-count="pageCount || 0"
          :page-size="pageData.size"
          :pager-count="pagerCount"
          @current-change="changePage"
          @size-change="changeSize"
          :total="sizeTotal"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    layout:{
      default:'total,sizes,prev, pager, next'
    },
    small:{
      default:false,
      type:Boolean
    },
    pagerCount:{
      default:7,
      type:Number
    },
    pageCount: {
      default: 0,
      type: Number
    },
    sizeTotal: {
      default: 0,
      type: Number
    },
    pageData: {
      default: () => {
        return {
          page: 1,
          size: 10
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    },
    changeSize(size) {
      this.$emit('changeSize', size)
      this.$storage.set('tablePageSize', size)
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-pagination{
  display: flex;
  align-items: center;
}
.pagination{
  border-top: var(--dt-border);
}
</style>
